@if (notification$ | async; as notification) {
  <ng-container>
    <nexweb-notification
      [notification]="notification"
      [headings]="headings"
      [labels]="labels"
      [dateTimeFormat]="dateTimeFormat"
      [mustAcknowledgeMessageRead]="mustAcknowledgeMessageRead"></nexweb-notification>
  </ng-container>
}
